const e = {
  name: "Philippines",
  dimensions: { width: 18, height: 21 },
  content: `
    <g>
      <path d="M17 11.5875C17 16.0075 13.42 19.5875 9 19.5875C4.58 19.5875 1 16.0075 1 11.5875L4 6.58752H14L17 11.5875Z" fill="none" stroke="currentColor" stroke-width="1.8824" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M1.81006 11.3668C5.36006 11.3668 5.46006 13.5868 9.00006 13.5868C12.5401 13.5868 12.4501 11.3668 16.0001 11.3668" fill="none" stroke="currentColor" stroke-width="2.1516" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M15 1.58752H12V5.58752" fill="none" stroke="currentColor" stroke-width="1.8824" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
    </g>
  `
};
export {
  e as Philippines
};
